// The demo request form emails the owner directly via Web3Forms: no backend,
// no database. The access key is a PUBLIC client key by design
// (submit-only, spam-filtered, rate-limited) — safe to ship in the bundle.
const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';
const WEB3FORMS_ACCESS_KEY = 'e40b3c7b-4e5c-4696-9236-a80f953a8e94';

async function sendViaWeb3Forms(fields) {
  const res = await fetch(WEB3FORMS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ access_key: WEB3FORMS_ACCESS_KEY, from_name: 'Emboscale Landing', ...fields }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    throw new Error(data.message || 'Something went wrong. Please email us directly at contact@emboscale.com.');
  }
  return data;
}

/**
 * Submit a demo request → emails the owner.
 * @param {Object} formData - { name, email, company, message? }
 */
export const submitDemoRequest = async (formData) => {
  await sendViaWeb3Forms({
    subject: `Demo request — ${formData.company || formData.name}`,
    name: formData.name,
    email: formData.email,
    company: formData.company,
    message: formData.message || '(no message)',
    heard_about_us: formData.source || '(not given)',
  });
  return { success: true, message: "Thank you! We'll contact you within 24 hours to schedule your demo." };
};
